import { SlideInModal } from '@/src/common/components/SlideInModal'
import { Button } from '@/src/common/components/Button'
import { router } from 'expo-router'
import { Image, View, Text } from 'react-native'
import BottomSheet from '@gorhom/bottom-sheet'
import { RefObject } from 'react'
import { DesignSystem } from '@/src/design-system'
import { CardBenefitsComponentsSummary } from './summary'
import type { CardBenefit } from '../statsig/store/useCardBenefitsParameterStore'
import Confetti from 'react-native-reanimated-confetti'
import * as Surveys from '@/src/experiences/surveys'
import { fontFamilies, mesaColorNames, typography } from '@/src/common/theme'

export const CardBenefitsComponentsEnrollmentSuccessModal = ({
  bottomSheetRef,
  selectedBenefit,
}: {
  bottomSheetRef: RefObject<BottomSheet | null>
  selectedBenefit: CardBenefit
}) => {
  Surveys.Hooks.useScreenUnmountTrigger('benefits_enrollment_success')

  return (
    <SlideInModal
      ref={bottomSheetRef}
      title={''}
      enableHandlePanningGesture={false}
      enableContentPanningGesture={false}
      handleComponent={null}
      showClose={false}
    >
      <Confetti fallSpeed={5000} />

      <View style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <DesignSystem.Animate>
          <View style={{ flex: 1, alignItems: 'center', marginBottom: 24 }}>
            <Image
              source={{ uri: selectedBenefit.preview_img }}
              style={{ height: 250, width: 250, aspectRatio: 1, borderRadius: 16 }}
            />
          </View>
        </DesignSystem.Animate>
        <View style={{ paddingHorizontal: 16, gap: 10 }}>
          <Text
            style={[
              typography['heading/heading3'],
              { color: mesaColorNames['Greyscale/900 #152438'], textAlign: 'center' },
            ]}
          >
            {`🎉 Congratulations 🎉\n You're Now Enrolled in ${selectedBenefit.header}`}
          </Text>
        </View>

        <CardBenefitsComponentsSummary
          summary={
            selectedBenefit.header === `Lowe's Home Improvement`
              ? selectedBenefit.summary.slice(0, 143)
              : selectedBenefit.summary
          }
        />

        <Button
          onPress={() => {
            bottomSheetRef.current?.close()
            // If there is a cta action after enrolling, keep on the same benefit screen
            if (selectedBenefit.enrolled_cta_action) {
              // no-op
            } else {
              router.dismissTo('/main/card-benefits')
            }
          }}
          buttonStyle={{
            backgroundColor:
              selectedBenefit.theme.backgroundColor ||
              mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'],
          }}
          titleStyle={{
            fontFamily: fontFamilies['PlusJakartaSans-Bold'],
            fontWeight: 700,
            fontSize: 16,
            color: selectedBenefit.theme.color || mesaColorNames['Mesa - Brand/White #FFFFFF'],
          }}
          title="Continue"
        />
      </View>
    </SlideInModal>
  )
}
